import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import TradeDetails from '../../../_shared/models/TradeDetails';
import {
  StyledHeader,
  StyledAsIs,
  StyledCloseButton,
  CloseIcon,
  StyledHeadline
} from './Styles';

const propTypes = {
  onClose: PropTypes.func.isRequired,
  bidContext: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.object,
      PropTypes.array
    ])
  ).isRequired,
  manufacturers: PropTypes.arrayOf(PropTypes.object).isRequired
};

const Header = ({ onClose, bidContext, manufacturers, testId }) => {
  const { isAsIs, tradeVehicleSummary, make } = bidContext;
  const [vehicleYear, setVehicleYear] = useState('');
  const [vehicleModel, setVehicleModel] = useState('');
  const [vehicleName, setVehicleName] = useState('');

  /**
   * Trade Details
   */
  useEffect(() => {
    setVehicleName(
      make ||
        TradeDetails.getManufacturerName(
          tradeVehicleSummary?.vehicleSummary,
          manufacturers
        )
    );
    setVehicleYear(tradeVehicleSummary?.vehicleSummary?.modelYear);
    setVehicleModel(tradeVehicleSummary?.vehicleSummary?.model?.displayName);
  }, [manufacturers, tradeVehicleSummary?.vehicleSummary, make]);

  return (
    <StyledHeader data-testid={testId}>
      <StyledCloseButton data-testid="close-bid-modal" onClick={onClose}>
        <CloseIcon />
      </StyledCloseButton>

      <StyledHeadline>
        {isAsIs && (
          <StyledAsIs>
            {/* As-is */}
            <FormattedMessage id="vdp.asis" />
          </StyledAsIs>
        )}
        <StyledHeadline.Year>{vehicleYear}</StyledHeadline.Year>
        <StyledHeadline.Make className="notranslate" title={vehicleName}>
          {vehicleName}
        </StyledHeadline.Make>
        <StyledHeadline.Model className="notranslate" title={vehicleModel}>
          {vehicleModel}
        </StyledHeadline.Model>
      </StyledHeadline>
    </StyledHeader>
  );
};

Header.propTypes = propTypes;

export default Header;
